<template>
  <div class="echarts-image-frame-wrapper">
    <div v-show="!isEmpty" class="echarts-image-info">暂无数据</div>
    <div v-show="isEmpty" class="echarts-image-frame-time">
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div v-show="isEmpty" class="echarts-image-frame" v-charts></div>
  </div>
</template>
<script>
import e4parent from "@/components/charts/e4parent";
export default {
  extends: e4parent,
  props: {
    exParams: Object,
  },
  data() {
    return {
      options: [
        {
          value: "1",
          label: "今年以来",
        },
        {
          value: "2",
          label: "成立以来",
        },
      ],
      value: "1",
    };
  },
  methods: {
    getFormatExParams() {
      let value = this.value;
      let curDate = new Date();
      let curYear = curDate.getFullYear();
      let minDate = new Date(curYear, 0, 1);
      let maxDate = new Date(curYear + 1, 0, 0);
      minDate = this.$filters.formatDate(minDate, "yyyy-MM-dd");
      maxDate = this.$filters.formatDate(maxDate, "yyyy-MM-dd");
      let dateMapping = [
        {
          EndDateMin: minDate,
          EndDateMax: maxDate,
        },
        {
          EndDateMin: minDate,
          EndDateMax: maxDate,
        },
        {
          EndDateMin: this.$filters.formatDate(
            new Date(2000, 0, 1),
            "yyyy-MM-dd"
          ),
          EndDateMax: maxDate,
        },
      ];
      let dateValue = dateMapping[value];
      return {
        ...dateValue,
        pageNo: 1,
        pageSize: 9999,
      };
    },
    getMockData() {
      let res = {
        x: [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
        ],
        y: null,
        data: [
          {
            name: "活跃度",
            value: [
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "264267",
              "360073",
              "0",
              "0",
              "0",
            ],
            dataType: 0,
          },
          { name: null, value: null, dataType: 1 },
        ],
      };
      return res;
    },
    getLegendData: function (data) {
      let legendData = [];
      let len = data.length;
      for (let i = 0; i < len; i++) {
        let item = data[i];
        let name = item.name;
        legendData.push(name);
      }
      return legendData;
    },
    getEchartsOptions(data) {
      data = data.data;
      let xData = data.x;
      let currData = data.data;
      // let legendData = this.getLegendData(currData);
      let option = {
        grid: [{ x: "10%", y: "10%", width: "85%", height: "80%" }],
        tooltip: {
          confine: true,
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#333333",
            },
            label: {
              backgroundColor: "#666666",
            },
          },
        },
        xAxis: [
          {
            data: xData,
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                opacity: 0.3,
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#f0f0f0",
              },
            },
            axisLabel: {
              show: true,
              color: this.chartsLabelColor || "#333333",
              fontSize: 14,
            },
          },
        ],
        yAxis: [
          {
            scale: true,
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                opacity: 0.3,
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#f0f0f0",
              },
            },
            axisLabel: {
              show: true,
              formatter: function (value, index) {
                return value.toFixed(2);
              },
              color: this.chartsLabelColor || "#333333",
              fontSize: 14,
            },
          },
        ],
        /* legend: {
          icon: "line",
          bottom: 10,
          data: legendData,
        }, */
        series: [],
      };
      let len = currData.length;
      for (let i = 0; i < len; i++) {
        let item = currData[i];
        // let name = item.name;
        // let dataType = item.dataType;
        let value = item.value;
        let serie = {
          // name: name,
          type: "line",
          hoverAnimation: false,
          showSymbol: false,
          areaStyle: {
            opacity: 0.2,
          },
          itemStyle: {
            normal: {
              color: "#5d8ff8",
            },
          },
          lineStyle: {
            width: 1,
          },
          data: value,
        };
        option.series.push(serie);
      }
      return option;
    },
  },
  watch: {
    value(val) {
      this.loadTimer && clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => {
        this.setOption();
      }, 200);
    },
  },
};
</script>
<style scoped>
.echarts-image-frame-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.echarts-image-frame {
  width: 100%;
  height: calc(100% - 30px);
  overflow: hidden;
}
.echarts-image-frame-wrapper {
  position: relative;
}
.echarts-image-info {
  position: absolute;
  text-align: center;
  top: 50%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
  color: #909399;
  font-size: 14px;
}
.echarts-image-frame-time {
  text-align: right;
  padding-right: 43px;
}
</style>
